/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';
import type { ZerogAccountSubmissionListRequest } from '../models/ZerogAccountSubmissionListRequest';
import type { ZerogStorageMinerListInfo } from '../models/ZerogStorageMinerListInfo';
import type { ZerogStorageMinerListRequest } from '../models/ZerogStorageMinerListRequest';
import type { ZerogStorageOverviewInfo } from '../models/ZerogStorageOverviewInfo';
import type { ZerogStorageSubmissionDetailRequest } from '../models/ZerogStorageSubmissionDetailRequest';
import type { ZerogStorageSubmissionListRequest } from '../models/ZerogStorageSubmissionListRequest';
import type { ZerogStorageSubmissionsDetailInfo } from '../models/ZerogStorageSubmissionsDetailInfo';
import type { ZerogStorageSubmissionsListInfo } from '../models/ZerogStorageSubmissionsListInfo';
import type { ZerogStorageSubmissionSummaryListInfo } from '../models/ZerogStorageSubmissionSummaryListInfo';
import type { ZerogStorageSubmissionSummaryRequest } from '../models/ZerogStorageSubmissionSummaryRequest';
import type { ZerogStorageUploaderListInfo } from '../models/ZerogStorageUploaderListInfo';
import type { ZerogStorageUploaderListRequest } from '../models/ZerogStorageUploaderListRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class StorageControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getStorageUploaderList({
        requestBody,
    }: {
        requestBody: ZerogStorageUploaderListRequest,
    }): CancelablePromise<ZerogStorageUploaderListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/storage/uploader/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getSubmissionDetail({
        requestBody,
    }: {
        requestBody: ZerogStorageSubmissionDetailRequest,
    }): CancelablePromise<ZerogStorageSubmissionsDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/storage/submissions',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getStorageSubmissionSummary({
        requestBody,
    }: {
        requestBody: ZerogStorageSubmissionSummaryRequest,
    }): CancelablePromise<ZerogStorageSubmissionSummaryListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/storage/submissions/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getSubmissionOverview({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<ZerogStorageOverviewInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/storage/submissions/overview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getStorageSubmissionList({
        requestBody,
    }: {
        requestBody: ZerogStorageSubmissionListRequest,
    }): CancelablePromise<ZerogStorageSubmissionsListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/storage/submissions/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAccountSubmissionList({
        requestBody,
    }: {
        requestBody: ZerogAccountSubmissionListRequest,
    }): CancelablePromise<ZerogStorageSubmissionsListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/storage/submissions/account/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getStorageMinerList({
        requestBody,
    }: {
        requestBody: ZerogStorageMinerListRequest,
    }): CancelablePromise<ZerogStorageMinerListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/storage/miner/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
